import type { Joined } from "./api";

/**
 * Remember a join on this device, so a reload or a locked phone rejoins as the same
 * participant — same score, same answers — instead of as a stranger.
 *
 * localStorage can be unavailable (private mode, blocked storage); every access is
 * guarded, and the only cost of failure is rejoining as someone new.
 */
const key = (code: string) => `engage.join.${code}`;

export function remember(joined: Joined): void {
  try {
    localStorage.setItem(key(joined.code), JSON.stringify(joined));
  } catch {
    /* storage unavailable: nothing to remember with */
  }
}

export function recall(code: string): Joined | null {
  try {
    const raw = localStorage.getItem(key(code));
    return raw ? (JSON.parse(raw) as Joined) : null;
  } catch {
    return null;
  }
}

export function forget(code: string): void {
  try {
    localStorage.removeItem(key(code));
  } catch {
    /* nothing to forget */
  }
}
